// extracted by mini-css-extract-plugin
export default {"loader":"DotLoader_loader__UL0xK","dot":"DotLoader_dot__p5tym","pulsate":"DotLoader_pulsate__k3jG7"};